import styled, {ThemeProps} from 'styled-components';

// COLOR Palette
import {defaultTheme} from '@stencil/build-theme';

// THEME
import {Theme} from '../../../../../stories/theme/types';

export const PolicyStyledWrapper = styled.div(
  props => `

  width: 100%;
  margin: 0 auto;
  max-width:120rem;
  background-color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
`,
);

export const PolicyHeaderStyled = styled.div(
  props => `

  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;

`,
);

export const PolicyHeaderTextStyled = styled.div(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(20)};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
`,
);

export const PolicyListBlock = styled.ul(
  props => `
  // background-color: ${props.theme.colors.goWhite.base};
  // padding: ${props.theme.spacing.xxlarge};
  // border-radius: ${props.theme.misc.borderRadius.large};
  // border-top-left-radius:0;
  // border-top-right-radius:0;
`,
);

export const PolicyListItemTextStyled = styled.li(
  (props: ThemeProps<Theme>) => `
  display: flex;
  font-size: ${props.theme.font.custom(16)};
  line-height: 1.4;
  list-style-type: none;
  // max-width: 50%;
  padding: 0 0 ${props.theme.spacing.large} 0;
`,
);

export const ErrorText = styled(PolicyListItemTextStyled)(
  props => `
  color: ${props.theme.colors.goRed.base};
  padding: ${props.theme.spacing.xlarge};
`,
);

export const staticCheckedIconProps = {
  height: '20px',
  fill: defaultTheme.colors.downriver.dark,
};

export const CheckedIconWrapperStyled = styled.span(
  props => `
  padding: 0 ${props.theme.spacing.large} 0 0;
`,
);

export const PolicyTextStyled = styled.span`
  /* margin-top: -4px; * to make for font deformalities - https://www.youtube.com/watch?v=jnV1u67_yVg */
`;
